import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/password-reset/request", { email });
      setSent(true);
    } catch { toast.error("Errore. Riprova più tardi."); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-white border border-border rounded-3xl p-10 shadow-xl">
        <Link to="/auth" className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-[#005C7A] mb-4"><ArrowLeft className="w-3 h-3" /> Torna al login</Link>
        <div className="w-14 h-14 rounded-2xl bg-[#005C7A] flex items-center justify-center mb-5"><Mail className="w-7 h-7 text-white" /></div>
        <h1 className="font-display text-3xl font-bold mb-1">Password dimenticata?</h1>
        <p className="text-sm text-muted-foreground mb-6">Inserisci la tua email. Se corrisponde a un account, ti mandiamo un link per reimpostare la password (valido 60 minuti).</p>
        {sent ? (
          <div className="bg-green-50 border-l-4 border-green-500 rounded-r-lg p-4 text-sm text-green-900" data-testid="pw-forgot-sent">
            ✅ <strong>Fatto!</strong> Se l'email è registrata, tra pochi minuti riceverai il link di reset. Controlla anche la cartella spam.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Email account</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tuoindirizzo@email.com" required autoFocus data-testid="pw-forgot-email" /></div>
            <Button type="submit" disabled={busy || !email} className="w-full rounded-full bg-[#005C7A] hover:bg-[#004A63]" data-testid="pw-forgot-submit">
              {busy ? "Invio in corso…" : "Invia link di reset"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
